import {
  ChangeDetectorRef,
  Component,
  EventEmitter,
  inject,
  Input,
  OnInit,
  ViewChild,
} from '@angular/core';
import { BrButton } from '@govbr-ds/webcomponents-angular/standalone';
import { TableFilterBarComponent } from '../../../../shared/components/table-filter-bar/table-filter-bar.component';

import jsPDF from 'jspdf';
import html2canvas from 'html2canvas';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ResumoConfirmacaoPrint } from './resumo-confirmacao-print/resumo-confirmacao-print.component';
import { AlertService } from '../../../../shared/services/alert.service';
import { endOfDay, parse, startOfDay } from 'date-fns';

@Component({
  selector: 'app-resumo-confirmacao-step',
  templateUrl: './resumo-confirmacao-step.component.html',
  styleUrls: ['./resumo-confirmacao-step.component.scss'],
  imports: [BrButton, TableFilterBarComponent],
})
export class ResumoConfirmacaoStepComponent implements OnInit {
  @Input() onResumoConfirmacao!: EventEmitter<void>;
  @Input() onStepChange!: EventEmitter<number>;
  @Input() onSubmitting!: EventEmitter<boolean>;
  @Input() confirmacaoVaga!: any;
  @Input() cicloSelected!: any;

  @ViewChild('printSection') printSection!: any;

  data: any[] = [];
  defaultPageSize = 1000;
  isSubmitting = false;

  private readonly alertService = inject(AlertService);
  private readonly modalService = inject(NgbModal);
  private readonly cdr = inject(ChangeDetectorRef);

  ngOnInit(): void {
    this.confirmacaoVaga.confirmacoesVagaIne
      .filter((confirmacao: any) => confirmacao.confirmacao)
      .forEach((confirmacao: any) => {
        this.addData(
          confirmacao.vagaCiclo.vagaPrograma.modalidadeFinanciamento.id,
          confirmacao,
        );
      });

    this.onSubmitting.subscribe((isSubmitting: boolean) => {
      this.isSubmitting = isSubmitting;
      this.cdr.detectChanges();
    });
  }

  get totalVagasConfirmadas(): number {
    return this.data.reduce((total, item) => total + item.total, 0);
  }

  get resumoVagas(): any[] {
    return this.data.map((item) => {
      return {
        modalidade: item.modalidade,
        total: item.total,
      };
    });
  }

  isPeriodoVigenteForEnable(): boolean {
    if (this.confirmacaoVaga?.rascunho === false) {
      return false;
    }
    if (this.cicloSelected) {
      const now = new Date();
      const dtInicio = startOfDay(
        parse(
          this.cicloSelected.confirmacaoVaga.inicio,
          'yyyy-MM-dd',
          new Date(),
        ),
      );
      const dtFim = endOfDay(
        parse(this.cicloSelected.confirmacaoVaga.fim, 'yyyy-MM-dd', new Date()),
      );
      return now >= dtInicio && now <= dtFim;
    }
    return false;
  }

  confirm(): void {
    this.alertService.confirm(
      'Atenção: esta ação é definitiva. Após a confirmação, as vagas não poderão ser editadas. Caso necessite de alterações, será necessário abrir um recurso dentro do prazo previsto no edital. Deseja confirmar?',
      () => {
        this.isSubmitting = true;
        this.onSubmitting.emit(true);
        this.onResumoConfirmacao.emit();
      },
    );
  }

  prev(): void {
    this.onStepChange.emit(2);
  }

  print(): void {
    const modalRef = this.modalService.open(ResumoConfirmacaoPrint, {
      size: 'lg',
    });
    modalRef.componentInstance.confirmacaoVaga = this.confirmacaoVaga;
    modalRef.componentInstance.municpio = this.confirmacaoVaga.municipio;
    modalRef.componentInstance.modalRef = modalRef;
    modalRef.componentInstance.data = this.data;
    modalRef.componentInstance.resumoVagas = this.resumoVagas;
    modalRef.componentInstance.totalVagasConfirmadas =
      this.totalVagasConfirmadas;
  }

  private addData(modalidadeId: any, value: any) {
    const index = this.data.findIndex(
      (item) => item.modalidadeId === modalidadeId,
    );

    if (index < 0) {
      this.data.push({
        modalidadeId: modalidadeId,
        modalidade: value.vagaCiclo.vagaPrograma.modalidadeFinanciamento.nome,
        pages: [
          {
            page: 1,
            data: [value],
          },
        ],
        currentPage: 1,
        total: 1,
        pageSize: this.defaultPageSize,
      });
    } else {
      if (
        this.data[index].pages[this.data[index].pages.length - 1].data.length ==
        this.defaultPageSize
      ) {
        this.data[index].pages.push({
          page: this.data[index].pages.length + 1,
          data: [value],
        });
        this.data[index].total = this.data[index].total + 1;
      } else {
        this.data[index].pages[this.data[index].pages.length - 1].data.push(
          value,
        );
        this.data[index].total = this.data[index].total + 1;
      }
    }
  }
}
